import "zone.js";

import { bootstrapApplication } from "@angular/platform-browser";
import { provideHttpClient } from "@angular/common/http";
import { provideAnimations } from "@angular/platform-browser/animations";
import { provideRouter, withHashLocation } from "@angular/router";

import { AppComponent } from "./app/app.component";
import { routes } from "./app/app.routes";

bootstrapApplication(AppComponent, {
  providers: [
    // Hash URLs (`/#/chat`) so refresh works on static hosts that don't rewrite to index.html.
    provideRouter(routes, withHashLocation()),
    provideHttpClient(),
    provideAnimations()
  ]
}).catch((err) => console.error(err));

